import styled from 'styled-components';

import {
  colorAccent50,
  colorAccent1600,
  fontFamilyPrimary,
  mediaQueryTabletMin,
} from '@/styleUtils';

export const ProductActionsList = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  @media ${mediaQueryTabletMin} {
    flex-wrap: nowrap;
  }
`;

export const ProductActionsItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
  padding: 12px;
  border-radius: 12px;
  background: ${colorAccent50};
`;

export const ActionTitle = styled.p`
  display: flex;
  gap: 8px;
  font: 700 14px/24px ${fontFamilyPrimary};
  color: ${colorAccent1600};
`;

export const ActionText = styled.p`
  font: 400 14px/24px ${fontFamilyPrimary};
`;
